var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"spinner-wrapper v-ctr h-ctr",class:[_vm.data.class, _vm.data.staticClass, _vm.props.slim ? 'slim' : ''],style:(_vm.data.staticStyle),attrs:{"aria-busy":"true"}},'div',_vm.data.attrs,false),[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.parent.$t('common.loading')))]),_c('div',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }